export default function BottomLine({ className }: { className?: string }) {
  return <div className={`w-full border-b border-ldir-blue-pale ${className ?? ""}`} />;
}
